/** Rank percentile: fraction of sortedValues strictly below value, as 0–100 (matches DivisionSummaryPanel). */
export function getPercentile(sortedValues: number[], value: number): number {
  if (sortedValues.length === 0) return 50;
  let low = 0;
  let high = sortedValues.length;
  while (low < high) {
    const mid = (low + high) >>> 1;
    if (sortedValues[mid]! < value) low = mid + 1;
    else high = mid;
  }
  return (low / sortedValues.length) * 100;
}
